"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = exports.CIRCLE_SIZE_PX = exports.CIRCLE_RADIUS = void 0;
var input_checkbox_1 = require("../../components/input/input.checkbox");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var tag_card_checkbox_style_1 = require("../tag.card.checkbox/tag.card.checkbox.style");
exports.CIRCLE_RADIUS = theme_1.DefaultTheme.spacingFactor * 4;
exports.CIRCLE_SIZE_PX = exports.CIRCLE_RADIUS * 2 + 'px';
exports.CSS = {
    container: 'c-TagCard',
    containerLeft: 'c-TagCard__left',
    toolbar: 'c-TagCard__toolbar',
    renamejob: 'c-TagCard__renamejob',
    isHovered: 'c-TagCard--is-hovered'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = (_b = {
            height: theme_1.DefaultTheme.space(10),
            'line-height': theme_1.DefaultTheme.space(6),
            display: 'flex',
            padding: theme_1.DefaultTheme.space(1),
            'align-items': 'center',
            'justify-content': 'center',
            '&:hover': {
                backgroundColor: theme_1.DefaultTheme.font.color.divider
            }
        },
        _b["& .".concat(exports.CSS.toolbar)] = {
            display: 'none'
        },
        _b["&:hover .".concat(exports.CSS.toolbar)] = {
            display: 'flex'
        },
        _b),
    _a[exports.CSS.isHovered] = {
        backgroundColor: theme_1.DefaultTheme.font.color.divider
    },
    _a[exports.CSS.containerLeft] = {
        display: 'flex',
        alignItems: 'center',
        width: exports.CIRCLE_SIZE_PX,
        height: exports.CIRCLE_SIZE_PX
    },
    _a[exports.CSS.toolbar] = {
        display: 'flex',
        position: 'relative'
    },
    _a[exports.CSS.renamejob] = {
        width: theme_1.DefaultTheme.space(8),
        height: theme_1.DefaultTheme.space(8)
    },
    _a["".concat(exports.CSS.container, " .").concat(tag_card_checkbox_style_1.CSS.container)] = {
        width: exports.CIRCLE_SIZE_PX,
        height: exports.CIRCLE_SIZE_PX
    },
    _a["".concat(exports.CSS.container, " .").concat(input_checkbox_1.CSS.container)] = {
        marginLeft: theme_1.DefaultTheme.spacingFactor
    },
    _a["".concat(exports.CSS.container, " .").concat(spinner_1.Spinner.CSS.container)] = {
        marginTop: theme_1.DefaultTheme.space(1)
    },
    _a);
//# sourceMappingURL=tag.card.style.js.map